<div *ngIf="loading$ | async" class="loader"></div>
